<template>
  <div id="hres3cu">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres3cuIndex"
            searchBoxAlias="hres3cu"
            :detailEvent="detailEvent"
            :editEvent="editEvent" />

    <detail-complaint v-show="detailDisp"
            :labels="labels[dash.nowLang]"
            :labelsButton="dash.button[dash.nowLang]"
            :detail="detail"
            :toggle="toggle"
            :nowLang="dash.nowLang"
            :indexSelected="indexSelected" />

    <detail-process v-show="detailProcessDisp"
            :labels="labels[dash.nowLang]"
            :labelsButton="dash.button[dash.nowLang]"
            :detail="detail"
            :detailProcess="detailProcess"
            :detailProcessColumns="columns[dash.nowLang].detailProcess"
            :toggle="toggle"
            :nowLang="dash.nowLang"
            :searchIndex="searchIndex"
            :indexSelected="indexSelected"
            :detailPopupProcess="detailPopupProcess"
            :setDetailProcessSelected="setDetailProcessSelected"
            :receivedHres3cuDetail="receivedHres3cuDetail"
            :receivedHres3cuDetailProcessPopupCreate="receivedHres3cuDetailProcessPopupCreate"
            :receivedHres3cuDetailProcessPopup="receivedHres3cuDetailProcessPopup"
            :postHres3cuDetailprocess="postHres3cuDetailprocess"
            :postHres3cuDetailprocessPopup="postHres3cuDetailprocessPopup" />

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres3cu/mutation-types'
import detailComplaint from 'components/hres3cu/detailComplaint'
import detailProcess from 'components/hres3cu/detailProcess'
import popupProcess from 'components/hres3cu/popupProcess'
import moment from 'moment'

export default {
  name: 'hres3cu',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      searchIndex: {}
    }
  },
  created () {
    this.receivedHres3cuColumnsLabels()
    this.receivedHres3cuIndex()
    // this.receivedHres3cuApprove()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES3CU_INDEX_DISP,
      detailDisp: types.GET_HRES3CU_DETAIL_DISP,
      detailProcessDisp: types.GET_HRES3CU_DETAIL_PROCESS_DISP,
      columns: types.GET_HRES3CU_COLUMNS,
      labels: types.GET_HRES3CU_LABELS,
      index: types.GET_HRES3CU_INDEX,
      indexSelected: types.GET_HRES3CU_INDEX_SELECTED,
      detail: types.GET_HRES3CU_DETAIL,
      detailProcess: types.GET_HRES3CU_DETAIL_PROCESS,
      detailPopupProcess: types.GET_HRES3CU_DETAIL_PROCESS_POPUP
    })
  },
  methods: {
    pageDetail (event) {
      let detailParams = this.indexSelected
      this.receivedHres3cuDetail(detailParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    pageProcessDetail (event) {
      let detailProcessParams = this.indexSelected
      this.receivedHres3cuDetailProcess(detailProcessParams)
      this.toggle('detailProcess')
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageProcessDetail()
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES3CU_INDEX_SELECTED,
      setDetailProcessSelected: types.SET_HRES3CU_DETAIL_PROCESS_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES3CU_PAGE,
      receivedHres3cuColumnsLabels: types.RECEIVED_HRES3CU_COLUMNS_LABELS,
      receivedHres3cuIndex: types.RECEIVED_HRES3CU_INDEX,
      receivedHres3cuDetail: types.RECEIVED_HRES3CU_DETAIL,
      receivedHres3cuDetailProcess: types.RECEIVED_HRES3CU_DETAIL_PROCESS,
      receivedHres3cuDetailProcessPopupCreate: types.RECEIVED_HRES3CU_DETAIL_PROCESS_POPUP_CREATE,
      receivedHres3cuDetailProcessPopup: types.RECEIVED_HRES3CU_DETAIL_PROCESS_POPUP,
      postHres3cuDetailprocess: types.POST_HRES3CU_DETAIL_PROCESS,
      postHres3cuDetailprocessPopup: types.POST_HRES3CU_DETAIL_PROCESS_POPUP
    })
  },
  components: {
    detailComplaint,
    detailProcess,
    popupProcess
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?950f02a4